import angular from 'angular';

angular.module('cloudX').directive('cxRelationDiscount', function() {
  return {
    restrict: 'E',
    replace: true,
    bindToController: {
      onbeforesave: '&',
      onaftersave: '&',
      value: '=data',
    },
    template: `<div>
                  <div class="margin5B">
                    <cx-enum-select data="ctrl.value.discountType"
                    type="discountType"
                    save="ctrl.submit(newValue, 'discountType')"></cx-enum-select>
                  </div>
                  <div ng-show="ctrl.value.discountType === 0" class="margin5B">
                    <a editable-number="ctrl.value.discount"
                      onbeforesave="ctrl.submit($data, 'discount')"
                      e-step="any"
                      e-class="form-control input-xx text-right"
                      blur="submit"
                      e-cx-percentage
                      e-limit-digits="5"
                      e-max="100"
                      e-min="0"
                      e-select-on-focus
                      e-inputgroupright="'%'"
                      ng-bind="ctrl.value.discount | percentage">
                    </a>
                  </div>
                  <div ng-show="ctrl.value.discountType>0" class="margin5B">
                    <a editable-number="ctrl.value.discount"
                      onbeforesave="ctrl.submit($data, 'discount')"
                      e-step="any"
                      e-class="form-control input-xx text-right"
                      blur="submit"
                      e-select-on-focus
                      e-limit-digits="5"
                      e-min="0"
                      ng-bind="ctrl.value.discount | dynCurrency:2:5">
                    </a>
                  </div>
                </div>`,
    require: ['ngModel', 'cxRelationDiscount'],
    controllerAs: 'ctrl',
    controller: [
      '$q',
      function($q) {
        const ctrl = this;

        ctrl.submit = function($data, field) {
          if (field === 'discount' && (typeof $data === 'undefined' || $data === null)) $data = 0;
          if (ctrl.value && ctrl.value[field] === $data) return false;

          let value = angular.copy(ctrl.value);
          value[field] = $data;
          if (field === 'discountType' && (ctrl.value.discountType === 0 || $data === 0)) {
            //Clear amount when switching between percentage and amounts
            value.discount = 0;
          }

          return $q
            .when(
              ctrl.onbeforesave({
                $data: value,
              }),
            )
            .then(function(result) {
              if (typeof result === 'string') return result;
              if (result !== false) {
                //Update model
                //ctrl.value=value;
              }
              ctrl.onaftersave({
                $data: value,
              });
              return result;
            });
        };
      },
    ],
  };
});
